import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { DelJobEventContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';
import { Pagination, PagingResponseModel, BasicApiResponseModel } from './../../../shared';
import { ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class DelJobEventService extends BaseApiTemplateService<DelJobEventContainerModel> {
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-job-event/backoffice-ep';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-job-event/' + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-job-event/' + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }

    public getByCriteria(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<DelJobEventContainerModel>> {

      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<DelJobEventContainerModel>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }

    public deleteJobEvent(jobGuid, visa: ApiVisa) {
      this.apiUrl = visa.api_domain_url+ this.endpoint_path + '/' + jobGuid;
      return this.httpClient.delete(this.apiUrl, this.getHttpHeader(visa))
    }
}